import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { DialogContentBase, DialogModule, DialogRef, WindowModule } from '@progress/kendo-angular-dialog';
import { FormFieldModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';

@Component({
  selector: 'app-confirmation-dialog-input',
  templateUrl: './confirmation-dialog-input.component.html',
  styleUrls: ['./confirmation-dialog-input.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, FormFieldModule, LabelModule
    , TextBoxModule, DialogModule, ButtonModule, WindowModule]
})


export class ConfirmationDialogInputComponent extends DialogContentBase implements OnInit, AfterViewInit {

  // new style viewchild proved problematic so reverted to old style
  @ViewChild('contentInput', { static: true }) contentInput!: ElementRef;
  
  /*-------------------------- Input / Outputs --------------------------------*/

  @Input() title!: string;
  @Input() content!: string;
  @Output() valueEntered = new EventEmitter<object>();

  /*-------------------------- public properties / methods --------------------*/

  public formGroup!: FormGroup;

  /*-------------------------- Constructor  --------------------------*/

  constructor(public dialog: DialogRef, private formBuilder: FormBuilder) {
    super(dialog);
  }

  /*----------------------------------- ng  --------------------------*/

  public ngOnInit(): void {

    this.formGroup = this.formBuilder.group({
      content: [''] // validation done manually
    });
  }

  ngAfterViewInit()
    : void {

    // set focus to the input upon initialization
    setTimeout(() => this.contentInput.nativeElement.focus(), 0);
  }

  /*--------------------------- event handlers  --------------------------*/

  public onOk(): void {

    const contentControl = this.formGroup.get('content');

    // Handle validation initialization manually

    // As there is only one input, we check only if they click Ok.
    // This means we can click Cancel without entering anything
    // even when we have by default given it focus which by default
    // would then trigger validation which would momentarily show the
    // error message when clicking the cancel button which not the desired behavior.

    // We add the validator check to ensure if the user clicks OK
    // then changes the value to empty, switches away and then clicks OK again
    // that we do not duplicate adding validation to the control which has already been added.

    if (!contentControl?.validator) {
      contentControl?.setValidators(Validators.required);
      contentControl?.updateValueAndValidity();
    }

    if (this.formGroup.valid) {
      this.valueEntered.emit(
        { success: true, value: this.formGroup.value.content }
      );
      this.dialog.close(true); // Close the dialog
    }
    else {
      // Set focus back to the input if validation fails
      setTimeout(() => this.contentInput.nativeElement.focus(), 0);
    }
      
  }

  protected onCancel(e: PointerEvent): void {

    e.preventDefault();
    
    this.valueEntered.emit({ success: false, value: '' });
    this.dialog.close(true);
  }

}
